



// 



import { Component } from '@angular/core';
import { fadeInOut } from '../../../services/animations';
import { ApiService } from '../../../services/api.service';
import { MatDialog } from '@angular/material';
import { AlertService, DialogType } from '../../../services/alert.service';
import { CreateEditCustomerModalComponent } from './create-edit-customer-modal/create-edit-customer-modal.component';
import { Router } from '@angular/router';
import { Service } from '../../../models/service.model';
import { Customer } from '../../../models/customer.model';

@Component({
    selector: 'customers',
    template: require('./customers.component.html'),
    styles: [require('./customers.component.css')],
    animations: [fadeInOut]
})
export class CustomersComponent {
    customers: Customer[];
    constructor(private router: Router, private apiService: ApiService, public dialog: MatDialog, private alertService: AlertService) {
        this.getCustomers();
    }

    getCustomers() {
        this.apiService.getCustomers().subscribe(r => {
            this.customers = r;
        })
    }

    createEditCustomer(customer: any) {
        let dialogRef = this.dialog.open(CreateEditCustomerModalComponent, {
            width: '600px',
            data: {
                currentCustomer: customer || {},
                //vendors: this.Customers
            }
        });

        dialogRef.afterClosed().subscribe(r => {
            this.getCustomers();
        })
    }

    deleteCustomer(customerId: number) {
        this.alertService.showDialog("Do you want to delete this customer ?", DialogType.confirm, val => {

            this.apiService.deleteCustomer(customerId).subscribe(r => {
                this.getCustomers();
            });
        });
    }

    onActivate(event) {
        if (event.type === 'click') {
            this.router.navigate(['/customers/' + event.row.customerId]);
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/components/quote-settings/customers/customers.component.ts